import { render, staticRenderFns } from "./VerificationCode.vue?vue&type=template&id=165a513b&scoped=true"
import script from "./VerificationCode.vue?vue&type=script&lang=js"
export * from "./VerificationCode.vue?vue&type=script&lang=js"
import style0 from "./VerificationCode.vue?vue&type=style&index=0&id=165a513b&prod&lang=scss&scoped=true"
import style1 from "./VerificationCode.vue?vue&type=style&index=1&id=165a513b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165a513b",
  null
  
)

export default component.exports